export default class ArrayHelper {
  static chunkArray (arr, size = 10) {
    const result = []
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size))
    }
    return result
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/Helpers/ArrayHelper.js